import React from 'react';
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { CompareProvider } from "./context/CompareContext";
import { UserProvider } from "./context/UserContext";
import ScrollToTop from "./components/ScrollToTop";
import { Toaster } from "./components/ui/sonner";

// Public Pages
import Home from "./pages/Home";
import ToolsPage from "./pages/ToolsPage";
import ToolDetail from "./pages/ToolDetail";
import ComparePage from "./pages/ComparePage";
import CategoriesPage from "./pages/CategoriesPage";
import CategoryPage from "./pages/CategoryPage";
import BlogPage from "./pages/BlogPage";
import BlogDetail from "./pages/BlogDetail";
import SubmitTool from "./pages/SubmitTool";

// Resources Pages
import GuidesPage from "./pages/GuidesPage";
import ReviewsPage from "./pages/ReviewsPage";
import AlternativesPage from "./pages/AlternativesPage";

// Company Pages
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import CareersPage from "./pages/CareersPage";
import PressPage from "./pages/PressPage";

// Legal Pages
import PrivacyPage from "./pages/PrivacyPage";
import TermsPage from "./pages/TermsPage";
import CookiesPage from "./pages/CookiesPage";

// Admin Pages
import AdminLogin from "./pages/admin/AdminLogin";
import AdminLayout from "./pages/admin/AdminLayout";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminTools from "./pages/admin/AdminTools";
import ToolForm from "./pages/admin/ToolForm";
import AdminBlogs from "./pages/admin/AdminBlogs";
import BlogForm from "./pages/admin/BlogForm";
import AdminSubmissions from "./pages/admin/AdminSubmissions";
import AdminReviews from "./pages/admin/AdminReviews";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <UserProvider>
          <CompareProvider>
            <BrowserRouter>
              <ScrollToTop />
              <Routes>
            {/* Public Routes */}
            <Route path="/" element={<Home />} />
            <Route path="/tools" element={<ToolsPage />} />
            <Route path="/tool/:slug" element={<ToolDetail />} />
            <Route path="/compare" element={<ComparePage />} />
            <Route path="/categories" element={<CategoriesPage />} />
            <Route path="/category/:slug" element={<CategoryPage />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:slug" element={<BlogDetail />} />
            <Route path="/submit" element={<SubmitTool />} />
            <Route path="/submit-tool" element={<SubmitTool />} />

            {/* Resources Routes */}
            <Route path="/guides" element={<GuidesPage />} />
            <Route path="/reviews" element={<ReviewsPage />} />
            <Route path="/alternatives" element={<AlternativesPage />} />

            {/* Company Routes */}
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/careers" element={<CareersPage />} />
            <Route path="/press" element={<PressPage />} />

            {/* Legal Routes */}
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/cookies" element={<CookiesPage />} />

            {/* Admin Routes */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route path="dashboard" element={<AdminDashboard />} />
              <Route path="tools" element={<AdminTools />} />
              <Route path="tools/new" element={<ToolForm />} />
              <Route path="tools/edit/:id" element={<ToolForm />} />
              <Route path="blogs" element={<AdminBlogs />} />
              <Route path="blogs/new" element={<BlogForm />} />
              <Route path="blogs/edit/:id" element={<BlogForm />} />
              <Route path="submissions" element={<AdminSubmissions />} />
              <Route path="reviews" element={<AdminReviews />} />
            </Route>
          </Routes>
          <Toaster position="bottom-right" />
        </BrowserRouter>
          </CompareProvider>
        </UserProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
